import { Box, Chip, Divider, Stack, Step, StepLabel, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PageStepperDefaultIco from "../../../assets/icons/PageStepperDefaultIco";
import StepperActiveIco from "../../../assets/icons/StepperActiveIco";
import StepperInprogressIco from "../../../assets/icons/StepperInprogressIco";
import SnackBar from "../../../component/SnackBar";
import { SowEnrich, SowToEnrich } from "../../../redux/action/Ignite";
import { CustomDiv } from "../../chat-bot/style";
import {
  CommonGrid2,
  StyledFlexColumnView,
} from "../../common-components/StyledComponents";
import CommonInputJd from "../../jobs/create-job/components/CommonInputJd";
import FileUpload from "../../matches/quick-match/components/FileUpload";
import { StepperStyle } from "../../matches/quick-match/style";
import CreateEnrich from "./components/CreateEnrich";
import JobOwnerExecutive from "../../jobs/create-job/components/JobOwnerExecutive";
import { TeamGetCall } from "../../../redux/action/UserManagement";
import { handleDataTime } from "../../common-components/JobFunction";
import { CreateJobDelete, CreateJobList } from "../../../redux/action/Job";
import SkillDeleteDialog from "../../common-components/DeleteDialog";
import { IconButton, TableCell } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteIco from "../../../assets/icons/DeleteIco";
import {
  DotColor,
  StatusChange,
} from "../../common-components/StyledComponents";
import CommonTable from "../../candidates/Table";
import { CustomizeSpan } from "../../jobs/style";
export default function SowEnrichment() {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const location = useLocation();
  const query = new URLSearchParams(useLocation().search);
  const queryValue = query?.get("value");
  const [sowTabValue, setSowTabValue] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [buttonLoading, setButtonLoading] = useState(false);
  const sowEnrichData = useSelector((state) => state.sow.sowEnrich);
  const [isDragging, setIsDragging] = useState(false);
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [userData, setUserData] = useState({
    account_executive: { username: "", id: "" },
    job_owner: { username: "", id: "" },
    user_list: [],
    date_time: null,
    loading: true,
  });

  const [enrichFile, setEnrichFile] = useState([]);
  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const [createJobList, setCreateJobList] = useState({
    data: [],
    currentPage: 1,
    totalPage: "",
    loading: true,
  });

  const [deleteTableRow, setDeleteTableRow] = useState({
    open: false,
    loading: false,
    content: "",
    id: "",
  });
  const limit = 5;
  const headerData = [
    { name: "Req ID", direction: "asc", sort: false, minWidth: "120px" },
    { name: "Title", direction: "asc", sort: false },
    { name: "Status", direction: "asc", sort: false },
    {
      name: "Compensation (Hourly / Annual)",
      direction: "asc",
      sort: false,
      minWidth: "200px",
    },
    { name: "Client", direction: "asc", sort: false },
    { name: "Created", direction: "asc", sort: false },
    {},
  ];

  const [tabData, setTabData] = useState([
    {
      label: "Upload JD",
      status: "In Progress",
    },
    {
      label: "Scoring",
      status: "Pending",
    },
    {
      label: "Score Report",
      status: "Pending",
    },
  ]);
  const handlePageChange = (page) => {
    setCreateJobList((prev) => ({ ...prev, currentPage: page }));
    fetchJobsList(limit, (page - 1) * limit);
  };

  const fetchJobsList = async (limit, offset) => {
    setCreateJobList((prev) => ({ ...prev, loading: true }));
    try {
      let params = {
        limit: limit,
        offset: offset,
        status: "Draft",
        jd_type: "SOW",
      };
      const response = await CreateJobList(params);
      const data = response.data;
      setCreateJobList((prev) => ({
        ...prev,
        data: data?.results || [],
        totalPage: data?.total_pages,
        loading: false,
      }));
    } catch (err) {
      setCreateJobList((prev) => ({ ...prev, loading: false }));
    }
  };
 
  const handleIconClick = (row) => {
  
    const dataFormat = {
      files: [],
      data: 
         [
          {
            ignite: row?.ignite_id ? row?.ignite_id : row.id,
          },
        ],
      

      status: "success",
    };

    dispatch(SowEnrich(dataFormat));
    setTabData((prev) =>
      prev.map((tab, index) =>
        index <= 1
          ? { ...tab, status: "Completed" }
          : { ...tab, status: "In Progress" },
      ),
    );
    navigate(`/sow-enrichment?value=1`);
    setSowTabValue(2);
  };


  const handleDeleteTableClose = () => {
    setDeleteTableRow({ open: false, loading: false, content: "", id: "" });
  };

  const handleDeleteRow = async () => {
    try {
      setDeleteTableRow((prev) => ({ ...prev, loading: true }));
      let data = await CreateJobDelete(deleteTableRow.id);
      let page =
        createJobList.currentPage === 1
          ? 1
          : createJobList.data?.length === 1
            ? createJobList.currentPage - 1
            : createJobList.currentPage;
      fetchJobsList(limit, (page - 1) * limit);
      setSnackbarState({
        open: true,
        message: data?.message,
        severity: "success",
      });
      handleDeleteTableClose();
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setDeleteTableRow((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleTableBodyData = (row, index) => {
    if (!row) return null;

    const handleDeleteClick = (e, row) => {
      e.stopPropagation();
      setDeleteTableRow((prev) => ({
        ...prev,
        open: true,
        content: row.job_title,
        id: row.id,
      }));
    };

    return (
      <>
        <TableCell>{row.req_id || "-"}</TableCell>
        <TableCell>{row.job_title || "-"}</TableCell>
        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.status === "Active"
                  ? "green"
                  : row.status === "Hold"
                    ? "orange"
                    : "#667085"
              }
            />
            {row.status || "-"}
          </StatusChange>
        </TableCell>
        <TableCell>{row.pay_rate || "-"}</TableCell>
        <TableCell>{row.client || "-"}</TableCell>
        <TableCell>
          {row.created_at ? new Date(row.created_at).toLocaleDateString() : "-"}
        </TableCell>
        <TableCell>
          <CommonGrid2 alignItems={"center"} gap={"0.8rem"} display={"flex"}>
            <VisibilityOutlinedIcon
              onClick={() => (buttonLoading ? {} : handleIconClick(row))}
              style={{
                cursor: buttonLoading ? "auto" : "pointer",
                fontSize: "21px",
                opacity: buttonLoading ? 0.4 : 1,
              }}
            />
            <IconButton
              onClick={(e) => handleDeleteClick(e, row)}
              disabled={buttonLoading}
              style={{ opacity: buttonLoading ? 0.4 : 1 }}
            >
              <DeleteIco strokeWidth={2} />
            </IconButton>
          </CommonGrid2>
        </TableCell>
      </>
    );
  };
  useEffect(() => {
    if (sowTabValue === 0) {
      fetchJobsList(limit, (createJobList.currentPage - 1) * limit);
    }
  }, [sowTabValue]);

  const handleCloseValidation = () =>
    setSnackbarState((prev) => ({ ...prev, open: false }));

  const commonFileValidationCheck = (
    commonFiles,
    allowedTypes,
    setCommonFiles,
    existingFiles,
  ) => {
    const validFiles = [];
    const invalidFiles = [];

    commonFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push({
          file,
          name: file.name,
          size: `${(file.size / 1024).toFixed(1)} KB`,
          type: file.type,
          progress: 0,
          buffer: 0,
          visible: false,
          delete: true,
          message: "",
        });
        setTabData((prev) =>
          prev.map((tab, index) =>
            index === 0 ? { ...tab, status: "Completed" } : tab,
          ),
        );
        setSowTabValue(1);
      } else {
        invalidFiles.push(file.name);
      }
    });

    const mergedFiles = [
      ...existingFiles,
      ...validFiles.filter(
        (newFile) =>
          !existingFiles.some(
            (existingFile) => existingFile.name === newFile.name,
          ),
      ),
    ];
    setCommonFiles(mergedFiles);
    const dataFormat = {
      files: mergedFiles
        ? mergedFiles.map((file) => ({
            name: file.name,
            size: file.size,
            type: file.type,
            progress: 0,
            buffer: 0,
            visible: false,
            delete: true,
            message: "",
          }))
        : [],
      data: [],
      status: "upload",
    };
    localStorage.setItem("SowEnrich", JSON.stringify(dataFormat));
    dispatch(SowEnrich(dataFormat));
    if (invalidFiles.length > 0) {
      setSnackbarState({
        open: true,
        message: `Unsupported file types: ${invalidFiles.join(", ")}`,
        severity: "error",
      });
    }
  };

  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(
      selectedFiles,
      allowedTypes,
      setEnrichFile,
      enrichFile,
    );
  };

  const handleDeleteFile = (index) => {
    const data = enrichFile.filter((_, i) => i !== index);
    const dataFormat = {
      files: data.map((file) => ({
        name: file.name,
        size: file.size,
        type: file.type,
        progress: file.progress,
        buffer: file.buffer,
        visible: file.visible,
        delete: file.delete,
        message: file.message,
      })),
      data: [],
      status: "upload",
    };

    dispatch(SowEnrich(dataFormat));

    if (data.length === 0) {
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "In Progress" }
            : { ...tab, status: "Pending" },
        ),
      );
      setSowTabValue(0);
    }
    setEnrichFile(data);
  };

  // Drag-and-drop functionality
  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);

    const selectedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(
      selectedFiles,
      allowedTypes,
      setEnrichFile,
      enrichFile,
    );
  };

  const handleButtonCommon = async (data) => {
    setButtonLoading(true);
    setTabData((prev) =>
      prev.map((tab, index) =>
        index < 1
          ? { ...tab, status: "Completed" }
          : index === 1
            ? { ...tab, status: "In Progress" }
            : tab,
      ),
    );
    setSowTabValue(1);
    if (
      localStorageData?.organization === "Demo" &&
      localStorageData?.role === "Demo"
    ) {
      const interval = setInterval(() => {
        setEnrichFile((prevFiles) =>
          prevFiles.map((f) => {
            const updatedProgress = f.progress + 10;
            const isComplete = updatedProgress >= 100;

            if (isComplete) {
              clearInterval(interval);

              setTimeout(() => {
                setTabData((prev) =>
                  prev.map((tab, index) =>
                    index <= 2 ? { ...tab, status: "Completed" } : tab,
                  ),
                );

                setSowTabValue(2);
                setSnackbarState({
                  open: true,
                  message: "Update Successfully",
                  severity: "success",
                });
              }, 500);

              return { ...f, progress: 100, buffer: 100 };
            }

            return {
              ...f,
              progress: updatedProgress,
              buffer: updatedProgress,
              visible: false,
              delete: false,
            };
          }),
        );
      }, 300);

      setTimeout(() => clearInterval(interval), 4000);
    } else {
      const formData = new FormData();
      enrichFile.forEach((fileObj, index) => {
        formData.append("file", fileObj.file);
      });
      formData.append("account_executive", userData?.account_executive?.id);
      formData.append("job_owner", userData?.job_owner?.id);
      formData.append(
        "submission_deadline",
        userData?.date_time
          ? new Date(
              userData.date_time.format("YYYY-MM-DDTHH:mm:ss"),
            ).toISOString()
          : "",
      );
      const dataFormat = {
        files: enrichFile
          ? enrichFile.map((file) => ({
              name: file.name,
              size: file.size,
              type: file.type,
              progress: 0,
              buffer: 0,
              visible: false,
              delete: false,
            }))
          : [],
        data: [],
        status: "Inprogress",
      };

      dispatch(SowEnrich(dataFormat));

      try {
        const response = await SowToEnrich(formData);
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          let boundaryIndex;
          while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
            const jsonString = buffer.slice(0, boundaryIndex + 1);
            buffer = buffer.slice(boundaryIndex + 1);
            const jsonResponse = JSON.parse(jsonString);
            try {
              await processJsonResponse(jsonResponse);
            } catch (e) {
              setTabData((prev) =>
                prev.map((tab, index) =>
                  index === 0
                    ? { ...tab, status: "Inprogress" }
                    : index === 1
                      ? { ...tab, status: "Pending" }
                      : tab,
                ),
              );
              setSowTabValue(0);
              setEnrichFile((prevFiles) =>
                prevFiles.map((f) => ({
                  ...f,
                  visible: true,
                  delete: true,
                  message: jsonResponse.message,
                })),
              );
              const dataFormat = {
                files: enrichFile
                  ? enrichFile.map(({ file, ...rest }) => ({
                      ...rest,
                      ...file,
                      message: jsonResponse.message,
                      visible: true,
                    }))
                  : [],
                data: [],
                status: "fail",
              };
              dispatch(SowEnrich(dataFormat));
              setSnackbarState({
                open: true,
                message: "Error parsing JSON",
                severity: "error",
              });
              setButtonLoading(false);
            }
          }
        }

        if (buffer) {
          const jsonResponse = JSON.parse(buffer);
          try {
            await processJsonResponse(jsonResponse);
          } catch (e) {
            setTabData((prev) =>
              prev.map((tab, index) =>
                index === 0
                  ? { ...tab, status: "Inprogress" }
                  : index === 1
                    ? { ...tab, status: "Pending" }
                    : tab,
              ),
            );
            setSowTabValue(0);
            setEnrichFile((prevFiles) =>
              prevFiles.map((f) => ({
                ...f,
                visible: true,
                delete: true,
                message: jsonResponse.message,
              })),
            );

            const dataFormat = {
              files: enrichFile
                ? enrichFile.map(({ file, ...rest }) => ({
                    ...rest,
                    ...file,
                    message: jsonResponse.message,
                    visible: true,
                  }))
                : [],
              data: [],
              status: "fail",
            };
            dispatch(SowEnrich(dataFormat));
            setSnackbarState({
              open: true,
              message: "Error parsing final JSON chunk",
              severity: "error",
            });
          }
        }
        setButtonLoading(false);
      } catch (error) {
        setTabData((prev) =>
          prev.map((tab, index) =>
            index === 0
              ? { ...tab, status: "Inprogress" }
              : index === 1
                ? { ...tab, status: "Pending" }
                : tab,
          ),
        );
        setSowTabValue(0);
        setEnrichFile((prevFiles) =>
          prevFiles.map((f) => ({
            ...f,
            visible: true,
            delete: true,
            message: "Error during the request",
          })),
        );
        const dataFormat = {
          files: enrichFile
            ? enrichFile.map(({ file, ...rest }) => ({
                ...rest,
                ...file,
                message: "Error during the request",
                visible: true,
              }))
            : [],
          data: [],
          status: "fail",
        };
        dispatch(SowEnrich(dataFormat));
        setSnackbarState({
          open: true,
          message: "Error during the request",
          severity: "error",
        });
        setButtonLoading(false);
      }
    }
  };

  const processJsonResponse = (jsonResponse) => {
    const { success, data, message } = jsonResponse;

    if (success && data?.percent !== undefined) {
      const dataFormat = {
        ...jsonResponse,
        files: enrichFile
          ? enrichFile.map(({ file, ...rest }) => ({
              ...rest,
              ...file,
              progress: data.percent,
              buffer: data.buffer || data.percent,
              visible: false,
              delete: false,
              progress_message: data.progress_message,
            }))
          : [],
        data: jsonResponse.data,

        status: "Inprogress",
      };

      dispatch(SowEnrich(dataFormat));
      setEnrichFile((prevFiles) =>
        prevFiles.map((f) => ({
          ...f,
          progress: data.percent,
          buffer: data.buffer || data.percent,
          visible: false,
          delete: false,
          progress_message: data.progress_message,
        })),
      );
    } else if (data && data?.length !== 0 && data[0]?.id) {
      const dataFormat = {
        ...jsonResponse,
        files: enrichFile
          ? enrichFile.map(({ file, ...rest }) => ({
              ...rest,
              ...file,
              progress: data.percent,
              buffer: data.buffer || data.percent,
              visible: false,
              delete: false,
            }))
          : [],
        data: jsonResponse.data,

        status: "success",
      };

      dispatch(SowEnrich(dataFormat));
      setSnackbarState({
        open: true,
        message: message,
        severity: "success",
      });
      setButtonLoading(false);
      navigate("/sow-enrichment?value=1");
      setTabData((prev) =>
        prev.map((tab, index) =>
          index <= 2 ? { ...tab, status: "Completed" } : tab,
        ),
      );
      setEnrichFile([]);
      setSowTabValue(2);
    } else if (!success) {
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "Inprogress" }
            : index === 1
              ? { ...tab, status: "Pending" }
              : tab,
        ),
      );
      setSowTabValue(0);
      setEnrichFile((prevFiles) =>
        prevFiles.map((f) => ({
          ...f,
          visible: true,
          delete: true,
          message: message,
        })),
      );
      const dataFormat = {
        ...jsonResponse,
        files: enrichFile
          ? enrichFile.map(({ file, ...rest }) => ({
              ...rest,
              ...file,
              message: message,
              visible: true,
            }))
          : [],
        data: jsonResponse.data,

        status: "fail",
      };
      dispatch(SowEnrich(dataFormat));
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "error",
      });
      setButtonLoading(true);
    }
  };

  useEffect(() => {
    if (enrichFile.length === 0) {
      if (sowEnrichData.status === "fail") {
        const dataFormat = {
          files: [],
          data: [],
          status: "",
        };
        dispatch(SowEnrich(dataFormat));
        setButtonLoading(false);
        setTabData((prev) =>
          prev.map((tab, index) =>
            index === 0
              ? { ...tab, status: "Inprogress" }
              : index === 1
                ? { ...tab, status: "Pending" }
                : tab,
          ),
        );
      } else if (sowEnrichData.status === "Inprogress") {
        setButtonLoading(true);
        setTabData((prev) =>
          prev.map((tab, index) =>
            index === 0
              ? { ...tab, status: "Completed" }
              : index === 1
                ? { ...tab, status: "In Progress" }
                : tab,
          ),
        );
        setSowTabValue(1);
      } else if (sowEnrichData.status === "upload") {
        const dataFormat = {
          files: [],
          data: [],
          status: "",
        };
        dispatch(SowEnrich(dataFormat));
        setButtonLoading(false);
        setTabData((prev) =>
          prev.map((tab, index) =>
            index === 0
              ? { ...tab, status: "Inprogress" }
              : index === 1
                ? { ...tab, status: "Pending" }
                : tab,
          ),
        );
      } else if (sowEnrichData.status === "") {
        navigate("/sow-enrichment");
      } else if (queryValue === "1") {
        setTabData((prev) =>
          prev.map((tab, index) =>
            index <= 1 ? { ...tab, status: "Completed" } : tab,
          ),
        );
        setSowTabValue(2);
      }
    } else if (queryValue === "1") {
      setTabData((prev) =>
        prev.map((tab, index) =>
          index <= 1 ? { ...tab, status: "Completed" } : tab,
        ),
      );
      setSowTabValue(2);
    }
  }, [sowEnrichData, enrichFile, queryValue]);

  useEffect(() => {
    if (sowEnrichData.status === "success" && queryValue !== "1") {
      const dataFormat = {
        files: [],
        data: [],
        status: "fail",
      };
      dispatch(SowEnrich(dataFormat));
      setSowTabValue(0);
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "Inprogress" }
            : { ...tab, status: "Pending" },
        ),
      );
    }
  }, [location]);

  useEffect(() => {
    if (sowTabValue === 0) {
      fetchUsersList();
    }
  }, [sowTabValue]);

  const QontoStepIcon = (props) => {
    const { active, completed } = props;
    const index = props.icon - 1;

    if (completed || (index === 2 && active)) {
      return <StepperActiveIco size={"28"} />;
    }
    if (active) {
      return <StepperInprogressIco size={"28"} />;
    } else return <PageStepperDefaultIco size={"28"} />;
  };

  const handleMenuItem = (value, name) => {
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchUsersList = async () => {
    try {
      setUserData((prev) => ({
        ...prev,
        loading: true,
      }));
      const usersList = await TeamGetCall();
      setUserData((prev) => ({
        ...prev,
        user_list: usersList?.data || [],
        loading: false,
      }));
    } catch (error) {
      setUserData((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
    }
  };

  return (
    <CustomDiv
      margin={queryValue === "1" ? "0px" : "1rem 1rem 1rem 1.5rem"}
      padding={queryValue === "1" ? "0px" : "1rem"}
      overflow={"hidden"}
      borderRadius={"10px"}
      background="#fff"
      border={queryValue === "1" ? "0px" : "1px solid rgba(0, 0, 0, 0.12)"}
    >
      {(sowTabValue === 0 || sowTabValue === 1) && (
        // <Grid2
        //   margin={"1rem 1rem 1rem 1.5rem"}
        //   padding={"1rem"}
        //   overflow={"hidden"}
        //   borderRadius={"10px"}
        //   background="#fff"
        //   border={"1px solid rgba(0, 0, 0, 0.12)"}
        // >
        <Fragment>
          <Typography variant="h2" margin="0px 0px 2.5rem 0px">
            {"Ignite - Virtual Marketplace"}
          </Typography>
          <StepperStyle
            activeStep={sowTabValue}
            margin={sowTabValue === 2 && "1rem  0px 2rem"}
            // style={{ width: "80%", margin: "1rem auto 2rem" }}
            // alternativeLabel
          >
            {tabData.map((step, index) => (
              <Step
                key={step.label}
                style={{
                  padding:
                    index === 2
                      ? "0px 0px 0px 1.2rem"
                      : index === 0
                        ? "0px 1.2rem 0px 0px"
                        : "0px 1.2rem",
                }}
              >
                <StepLabel StepIconComponent={QontoStepIcon}>
                  <CommonGrid2
                    display="flex"
                    flexDirection="column"
                    gap="5px"
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Typography variant="span" color="#344054" fontWeight={600}>
                      {step.label}
                    </Typography>

                    <Typography
                      variant="span"
                      color={
                        step.status === "Completed"
                          ? "#17B26A"
                          : step.status === "In Progress"
                            ? "#7F56D9"
                            : "#5B738B"
                      }
                    >
                      {step.status}
                    </Typography>
                  </CommonGrid2>
                </StepLabel>
              </Step>
            ))}
          </StepperStyle>
          
          <CommonInputJd
            title={"Import SoW to Enrich"}
            buttonName={"Import SoW"}
            loading={buttonLoading}
            disabled={sowEnrichData.files?.length === 0}
            handleButtonCommon={() => handleButtonCommon()}
            customStyle={{ marginTop: "-1rem" }}
          >
            <StyledFlexColumnView>
              <Box sx={{ mb: 3 }}>
                <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mb: 1 }}>
                  <Typography fontSize="13px" fontWeight={600} color="#101828">
                    SoW/Job Description File
                  </Typography>
                  <Typography fontSize="13px" fontWeight={400} color="#667085">
                    (Please upload a clear and readable SoW file only)
                  </Typography>
                  <Typography fontSize="13px" fontWeight={600} color="#F04438">
                    *
                  </Typography>
                </Stack>
                <Stack
                  direction="row"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={0.75}
                  sx={{
                    px: 1.5,
                    py: 1,
                    bgcolor: "#F9FAFB",
                    border: "1px solid #EAECF0",
                    borderRadius: "8px",
                    width: "fit-content",
                  }}
                >
                  <Typography fontSize="11.5px" fontWeight={500} color="#667085">
                    Supported formats:
                  </Typography>
                  {["PDF", "DOC", "DOCX"].map((fmt) => (
                    <Chip
                      key={fmt}
                      label={fmt}
                      size="small"
                      sx={{
                        height: "22px",
                        fontSize: "11px",
                        fontWeight: 600,
                        color: "#6941C6",
                        bgcolor: "#F4EBFF",
                        border: "1px solid #E9D7FE",
                        borderRadius: "6px",
                        "& .MuiChip-label": { px: "8px" },
                      }}
                    />
                  ))}
                  <Divider orientation="vertical" flexItem sx={{ mx: 0.5, borderColor: "#EAECF0" }} />
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography fontSize="11.5px" fontWeight={500} color="#667085">
                      Max size:
                    </Typography>
                    <Typography
                      fontSize="11.5px"
                      fontWeight={700}
                      color="#344054"
                      sx={{
                        px: 0.75,
                        py: 0.1,
                        bgcolor: "#F2F4F7",
                        borderRadius: "4px",
                        border: "1px solid #D0D5DD",
                      }}
                    >
                      5 MB
                    </Typography>
                  </Stack>
                </Stack>
              </Box>
              <FileUpload
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onChange={handleFileUpload}
                isDragging={isDragging}
                files={
                  localStorageData?.organization === "Demo" &&
                  localStorageData?.role === "Demo"
                    ? enrichFile
                    : sowEnrichData.files
                }
                handleDeleteFile={handleDeleteFile}
                disabled={buttonLoading}
                marginBottom={2}
              />
              <JobOwnerExecutive
                userData={userData}
                handleMenuItem={handleMenuItem}
                handleDataTime={(newValue) =>
                  handleDataTime(newValue, setUserData)
                }
                loading={userData.loading}
              />
            </StyledFlexColumnView>
          </CommonInputJd>
          <CommonTable
            data={createJobList.data}
            columns={headerData}
            onSortChange={(col) => console.log("Sort by", col)}
            handleTableBodyData={handleTableBodyData}
            paginationProps={{
              count: createJobList.totalPage,
              page: createJobList.currentPage,
              onPageChange: (page) => handlePageChange(page),
            }}
            withPagination={true}
            loading={createJobList.loading}
            customStyle={{
              "& .MuiTableRow-root": {
                cursor: buttonLoading ? "auto" : "pointer",
              },
              "& .MuiTableRow-head": {
                cursor: "auto",
              },
            }}
            handleRowClick={buttonLoading ? {} : handleIconClick}
          />
        </Fragment>
      )}

      {sowTabValue === 2 && (
        <>
          <CreateEnrich
            height="100vh"
            sowId={
              localStorageData?.organization === "Demo" &&
              localStorageData?.role === "Demo"
                ? localStorageData?.demo_config?.demo_ignite
                : sowEnrichData?.data?.data?.[0]?.ignite
            }
            stepperCondition={true}
          />
        </>
      )}
      <SkillDeleteDialog
        deleteDialog={deleteTableRow.open}
        handleDeleteDialogClose={handleDeleteTableClose}
        handleDeleteSkill={handleDeleteRow}
        buttonLoading={deleteTableRow.loading}
        title={"Delete Job"}
        content={deleteTableRow.content}
      />
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
